export default {
  title: 'ExpertOrder',
  form: {
    api_key: {
      label: 'API key',
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    error: 'Failed to save changes',
    success: 'Changes got saved',
  },
  connected: {
    title: 'ExpertOrder is connected',
    description: 'This integration is set up.',
  },
};
